const LEDGER = 'ledger';
const TREZOR = 'trezor';
const BITBOX = 'bitbox';
const SECALOT = 'secalot';
const KEEPKEY = 'keepkey';
const MEW_CONNECT = 'mew_connect';
const KEYSTORE = 'keystore';
const MNEMONIC = 'mnemonic';
const WEB3_WALLET = 'web3_wallet';
const PRIV_KEY = 'priv_key';
export {
  LEDGER,
  TREZOR,
  BITBOX,
  SECALOT,
  KEEPKEY,
  MEW_CONNECT,
  KEYSTORE,
  MNEMONIC,
  WEB3_WALLET,
  PRIV_KEY
};
